<template>
  <form class="form">
    <v-layout row no-gutters>
      <v-flex order-sm1>
        <v-card tile flat class="tbl-row">
          <v-card-text style="padding-left: 0" class="card-text">
            <div>
              <input
                :class="{ 'errors-input': !$v.form.name.minLength }"
                class="custom-input"
                v-model.trim="form.name"
                id="bidder-name"
                placeholder="Name"
              />
            </div>
            <span class="errors-text" v-if="!$v.form.name.minLength && showErrors"
              >Name must have at least 2 letters.</span
            >
            <span class="errors-text" v-if="!$v.form.name.required && showErrors"
              >Name is required</span
            >
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout no-gutters>
      <v-flex class="flex-center align-start">
        <v-card tile flat class="tbl-row">
          <v-card-text style="padding-left: 0" class="card-text">
            <div>
              <input
                @input="checkEmail"
                :class="{ 'errors-input': !$v.form.email }"
                class="custom-input"
                type="email"
                v-model.trim="form.email"
                id="bidder-email"
                placeholder="Email"
              />
            </div>
            <span class="errors-text" v-if="!$v.form.email.email && showErrors"
              >Wrong Email Type</span
            >
            <span class="errors-text" v-else-if="!$v.form.email.required && showErrors"
              >Email is required</span
            >
            <span class="errors-text" v-else-if="existTheSameEmail && showErrors"
              >Participant with this e-mail is registered</span
            >
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout v-if="isBidValueRequiredType(auction.procurementMethodType)" no-gutters>
      <v-flex class="justify-center align-start">
        <v-card tile flat class="tbl-row">
          <v-card-text style="padding-left: 0" class="card-text">
            <v-text-field
              color="darkgrey"
              :prefix="getCurrencySymbol()"
              :class="{ 'errors-input': !$v.form.bid }"
              class="elevation-0 pt-0 mt-0 input-bid"
              v-model.trim="form.bid"
              id="bidder-bid"
              placeholder="Bid"
              hide-details
            >
            </v-text-field>

            <span class="errors-text" v-if="!$v.form.bid.required && showErrors"
              >Bid is required</span
            >
            <span class="errors-text" v-if="!$v.form.bid.minValue && showErrors"
              >Bid must be more then Initial Price</span
            >
            <span class="errors-text" v-if="!$v.form.bid.maxValue && showErrors"
              >Bid must be less then Initial Price</span
            >
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <template v-if="isMultilotType(auction.procurementMethodType)">
      <v-layout v-for="lot in auction.lots" :key="lot.id" no-gutters>
        <v-flex class="justify-center align-start">
          <v-card tile flat class="tbl-row">
            <v-card-text style="padding-left: 0" class="card-text">
              <div class="lot-bid-label">
                <strong>{{ lot.title }}</strong>
                <span class="lot-bid-starting">
                  Starting price:
                  {{
                    formatCurrencyAmount(lot.value.amount, lot.value.currency, {
                      prefixSymbol: true,
                    })
                  }}
                </span>
              </div>
              <v-text-field
                color="darkgrey"
                :prefix="getCurrencySymbol()"
                :class="{
                  'errors-input': $v.form.lotBids[lot.id] && $v.form.lotBids[lot.id].$invalid,
                }"
                class="elevation-0 pt-0 mt-0 input-bid"
                v-model.trim="form.lotBids[lot.id]"
                :id="`bidder-bid-${lot.id}`"
                placeholder="Bid"
                hide-details
              >
              </v-text-field>

              <span
                class="errors-text"
                v-if="$v.form.lotBids[lot.id] && !$v.form.lotBids[lot.id].maxValue && showErrors"
                >Bid must be less then Initial Price</span
              >
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout no-gutters>
        <v-flex class="justify-center align-start">
          <v-card tile flat class="tbl-row">
            <v-card-text style="padding-left: 0" class="card-text">
              <span class="lot-bid-hint">Bidding on a lot is optional -- leave any lot's field blank to skip it.</span>
              <span
                class="errors-text"
                v-if="showErrors && !hasAtLeastOneLotBid"
                >Enter a bid for at least one lot.</span
              >
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </template>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-layout row no-gutters>
          <v-flex class="flex-center align-start">
            <v-card tile text class="tbl-row">
              <v-card-text style="padding-left: 0" class="card-text">
                <v-btn
                  :disabled="false"
                  v-on="on"
                  style="margin-left: 0; width: 100%"
                  register
                  id="-bidder"
                  color="primary"
                  @click="addNewBider"
                >
                  Register the Bidder
                </v-btn>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </template>
      <span>A person or organization making a formal offer during an auction.</span>
    </v-tooltip>
  </form>
</template>

<script>
import AuctionsService from '@/services/AuctionsService';
import { mapActions, mapMutations } from 'vuex';
import { required, email, minLength, minValue, maxValue } from 'vuelidate/lib/validators';
import utils from '@/utils/utils';
import errorParser from '@/utils/errorParser';
import { formatCurrencyAmount } from '@/utils/numberFormat';
import {
  ENGLISH_TYPE,
  TEXAS_TYPE,
  isReverseLikeType,
  isBidValueRequiredType,
  isMultilotType,
} from '@/constants/auction';

export default {
  data() {
    return {
      editAuction: false,
      editBid: false,
      editBidValue: false,
      existTheSameEmail: false,
      showEditBid: {
        isOpen: false,
        element: '',
        elementValue: '',
        name: false,
      },
      copyBidInfo: {
        name: '',
        email: '',
        bid: '',
        value: '',
      },
      widgetTitle: '',
      timer: '',
      snackbar: false,
      subscribers: [],
      subscribersBid: '',

      sortBidders: {
        descending: true,
        sortBy: 'date',
      },
      form: {
        name: '',
        email: '',
        bid: null,
        lotBids: {},
      },
      showErrors: false,
      participationURL: '',
      bid: null,
      dialog: false,
      isParticipationUrl: false,
      isBid: false,
    };
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    auction: {
      type: Object,
    },
  },
  created() {
    if (isMultilotType(this.auction.procurementMethodType) && Array.isArray(this.auction.lots)) {
      const lotBids = {};
      this.auction.lots.forEach((lot) => {
        lotBids[lot.id] = null;
      });
      this.form.lotBids = lotBids;
    }
  },
  computed: {
    hasAtLeastOneLotBid() {
      return Object.values(this.form.lotBids).some(
        (value) => value !== '' && value !== null && value !== undefined
      );
    },
  },
  methods: {
    ...mapActions(['setLoading', 'showSnackbar']),
    ...mapMutations(['bidderCreatedBid', 'setAnonymousParticipationUrl']),
    isBidValueRequiredType(type) {
      return isBidValueRequiredType(type);
    },
    isMultilotType(type) {
      return isMultilotType(type);
    },
    formatCurrencyAmount,
    getCurrencySymbol() {
      return utils.getCurrencySymbol(this.auction.value.currency);
    },
    checkEmail() {
      this.existTheSameEmail = false;
    },
    resetForm() {
      this.showErrors = false;
      this.form.name = '';
      this.form.email = '';
      this.form.bid = null;
      Object.keys(this.form.lotBids).forEach((lotId) => {
        this.form.lotBids[lotId] = null;
      });
    },
    submitBidderRegistration(jsonToSend, token) {
      this.setLoading({ show: true, text: 'Saving...' });
      let request;
      if (token) {
        request = AuctionsService.createBidderWithInvitation(this.auction.id, jsonToSend, token);
      } else {
        request = AuctionsService.createBider(this.auction.id, jsonToSend);
      }
      request
        .then((response) => {
          this.auction.bids.push(response.data);
          this.resetForm();
          this.showSnackbar(`You were registered to participate in Auction ${this.auction.title}`);
          this.setLoading({ show: false, text: '' });
          if (token) {
            this.bidderCreatedBid(true);
            this.setAnonymousParticipationUrl(response.data.participationUrl);
          }
        })
        .catch((error) => {
          errorParser({
            error,
            setLoading: this.setLoading,
            showSnackbar: this.showSnackbar,
            onSameEmailExists: () => {
              this.existTheSameEmail = true;
            },
          });
          this.$emit('getDetailAuctionRequest');
        });
    },
    addNewBider() {
      let token = this.$route.query.invitation_token;
      this.showErrors = true;
      let existEmail = false;
      if (this.auction.bids && this.form.email) {
        for (let key in this.auction.bids) {
          if (
            this.form.email.toLowerCase() ===
            this.auction.bids[key].tenderers[0].contactPoint.email.toLowerCase()
          ) {
            existEmail = true;
          }
        }
        this.existTheSameEmail = existEmail;
      }
      if (isMultilotType(this.auction.procurementMethodType)) {
        if (this.existTheSameEmail || this.$v.form.$invalid) {
          return;
        }
        if (!this.hasAtLeastOneLotBid) {
          this.showErrors = true;
          return;
        }
        const jsonToSend = {
          tenderers: [
            {
              name: this.form.name,
              contactPoint: {
                email: this.form.email,
              },
            },
          ],
          lotValues: this.auction.lots
            .filter((lot) => {
              const value = this.form.lotBids[lot.id];
              return value !== '' && value !== null && value !== undefined;
            })
            .map((lot) => ({
              value: {
                amount: this.form.lotBids[lot.id],
                currency: this.auction.value.currency,
              },
              relatedLot: lot.id,
            })),
        };
        this.submitBidderRegistration(jsonToSend, token);
        return;
      }
      if (
        !this.existTheSameEmail &&
        (!this.$v.form.$invalid ||
          (!this.$v.form.email.$invalid &&
            !this.$v.form.name.$invalid &&
            !this.$v.form.bid.$invalid) ||
          (!isBidValueRequiredType(this.auction.procurementMethodType) &&
            (!this.$v.form.$invalid ||
              (!this.$v.form.email.$invalid && !this.$v.form.name.$invalid))))
      ) {
        let jsonToSend;
        if (isBidValueRequiredType(this.auction.procurementMethodType)) {
          jsonToSend = {
            tenderers: [
              {
                name: this.form.name,
                contactPoint: {
                  email: this.form.email,
                },
              },
            ],
            value: {
              amount: this.form.bid,
              currency: this.auction.value.currency,
            },
          };
        } else if (
          (!isBidValueRequiredType(this.auction.procurementMethodType) && !this.$v.form.$invalid) ||
          (!this.$v.form.email.$invalid && !this.$v.form.name.$invalid)
        ) {
          jsonToSend = {
            tenderers: [
              {
                name: this.form.name,
                contactPoint: {
                  email: this.form.email,
                },
              },
            ],
          };
        }
        this.submitBidderRegistration(jsonToSend, token);
      }
    },
  },
  validations() {
    if (isMultilotType(this.auction.procurementMethodType)) {
      const lotBids = {};
      (this.auction.lots || []).forEach((lot) => {
        // Partial-lot bidding: each lot's bid is OPTIONAL (bid on a subset of
        // lots). If an amount IS entered it must not exceed that lot's starting
        // price (reverse). "At least one lot" is enforced via hasAtLeastOneLotBid.
        lotBids[lot.id] = {
          maxValue: lot.value ? maxValue(lot.value.amount) : false,
        };
      });
      return {
        form: {
          name: {
            required,
            minLength: minLength(2),
          },
          email: {
            required,
            email,
          },
          lotBids,
        },
      };
    }
    return {
      form: {
        name: {
          required,
          minLength: minLength(2),
        },
        email: {
          required,
          email,
        },
        bid: {
          required,
          minValue:
            this.auction.value &&
            (this.auction.procurementMethodType === ENGLISH_TYPE ||
              this.auction.procurementMethodType === TEXAS_TYPE)
              ? minValue(this.auction.value.amount)
              : 1,
          maxValue:
            this.auction.value && isReverseLikeType(this.auction.procurementMethodType)
              ? maxValue(this.auction.value.amount)
              : false,
        },
      },
    };
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-text-field__prefix,
::v-deep .v-text-field__suffix {
  font-weight: 500;
  color: #216169;
  font-size: 12px;
  opacity: 0.5;
}

.bidders tr {
  position: relative;
}
.edit-bid {
  position: absolute;
  top: 10px;
  right: 0;
}
.edit-bid-section {
  position: absolute;
  right: 0;
  bottom: 50%;
  opacity: 0.8;
  font-size: 19px;
  transform: translateY(50%);
  .v-icon {
    font-size: 20px;
  }
}
.edit-bid-section-event {
  position: relative;
  right: 0;
  bottom: 50%;
  opacity: 0.8;
  font-size: 19px;
  transform: translateY(50%);
  .v-icon {
    font-size: 20px;
  }
}
h1 {
  color: #396;
  font-weight: 100;
  font-size: 40px;
  margin: 20px 0px 20px;
}
::v-deep .input-bid {
  .v-input__slot {
    padding: 0 16px;
    &::before,
    &::after {
      display: none;
    }
    input {
      &,
      &::placeholder {
        color: #216169;
        font-size: 12px;
        font-weight: normal;
      }
    }
  }
}

.errors-input {
  outline: 2px solid #e62a2aa3;
}
.errors-text {
  font-size: 11px;
  color: #e62a2aa3;
  margin-top: 8px;
  display: block;
}
.lot-bid-hint {
  font-size: 11px;
  color: #216169;
  opacity: 0.75;
  margin-top: 8px;
  display: block;
}
.lot-bid-label {
  display: flex;
  flex-direction: column;
  margin-bottom: 6px;
  color: #216169;
  strong {
    font-size: 12px;
  }
  .lot-bid-starting {
    font-size: 11px;
    opacity: 0.75;
  }
}
div strong {
  font-size: 12px;
}
.align-start {
  align-items: start;
}
.label-heading {
  display: block;
  border-left: 5px solid #2e7f89;
  box-sizing: border-box;
  margin-left: -18px;
  padding-left: 14px;
}
h3 {
  text-align: left;
  color: #2e7f89;
  margin-top: 36px;
}
.subscribers-form {
  padding: 0;
  display: flex;
  width: 55%;
  min-width: 900px;
  margin: 0 auto 9px auto;
  justify-content: space-between;
  flex-direction: column;
  background: #ffffff;
}
.inline {
  display: inline-block;
}
.subtitle-form {
  padding: 0 7px 0 17px;
  width: 55%;
  min-width: 900px;
  margin: 0 auto 14px auto;
  justify-content: space-between;
  flex-direction: row;
  .tbl-row,
  .tbl-row-rewerse {
    
    background: transparent;
    font-size: 9px;
    font-weight: 400;
  }
}
.strong {
  
}
.data-table td {
  text-align: left !important;
}
.tbl-row {
  width: 100%;
  text-align: left;
}
.tbl-row-rewerse {
  text-align: right;
}
.flex-center {
  display: flex;
  overflow: hidden;
}
.material-icons:hover {
  color: #2e7f89;
}
.form .card-text {
  padding: 6px 16px;
}
.card-text {
  padding: 12px 16px;
}
.custom-input-edit {
  line-height: 1.6rem;
  background: rgba(169, 169, 169, 0.2);
  padding: 0 0 0 6px;
  border: 2px solid rgb(46, 127, 137);
}
.custom-input {
  height: 42px;
  margin-bottom: 0;
  width: 100%;
}
.v-text-field {
  & ::v-deep .v-input__slot {
    box-shadow: none !important;
    border-radius: 0;
    min-height: auto;
    height: 42px;
    background: rgba(196, 196, 196, 0.3) !important;
    border: 2px solid transparent;
  }
}

.v-input--is-focused {
  & ::v-deep .v-input__slot {
    border: 2px solid rgb(46, 127, 137);
  }
}

.copy {
  cursor: pointer;
}
@media (max-width: 1000px) {
  img {
    margin-left: 34px;
  }
  .subtitle-form {
    min-width: 90% !important;
  }
  .subscribers-form,
  .invite {
    min-width: 90% !important;
  }
}
</style>
